import React from 'react'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link as AnchorLink } from 'react-scroll'

const MobileMenu = props => {
  const [isOpen, setOpen] = React.useState(false)

  const openMenu = () => {
    setOpen(true)
  }

  const closeMenu = () => {
    setOpen(false)
  }

  return (
    <div className="mobile-menu">
      <button className="mobile-menu-toggle" onClick={openMenu}>
        <FontAwesomeIcon icon={faBars} />
      </button>
      <div className={isOpen ? 'mobile-menu-holder open' : 'mobile-menu-holder'}>
        <ul>
          <li onClick={closeMenu}>&times; Close</li>

          {props.entries.map(element => {
            return (
              <li key={element.target}>
                <AnchorLink
                  smooth={true}
                  offset={-80}
                  duration={250}
                  onClick={closeMenu}
                  to={element.target}
                >
                  {element.label}
                </AnchorLink>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default MobileMenu
